import { createFileRoute } from '@tanstack/react-router';
import { CustoView } from '@/modules/agentes/components/AgentesGestao';

// Pilar Custo & uso do módulo Agentes (gestão) — admin-only.
export const Route = createFileRoute('/_authed/agentes_/custo')({
  component: CustoView,
});
